<template>
<div>
  <el-card body-style="padding: 0">
    <el-form ref="queryForm" :model="queryForm" label-width="100px">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="任务编号" prop="taskId">
            <el-input v-model="queryForm.taskId" placeholder="请输入任务编号"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="商家账号" prop="businessName">
            <el-input v-model="queryForm.businessName" placeholder="请输入商家账号"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="任务名称" prop="taskTitle">
            <el-input v-model="queryForm.taskTitle" placeholder="请输入任务名称"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="任务类型" prop="taskType">
            <el-select v-model="queryForm.taskType" clearable placeholder="请选择任务类型">
              <el-option
                  v-for="item in allTaskTypes"
                  :key="item.id"
                  :label="item.taskName"
                  :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="8" :offset="8">
          <el-form-item>
            <el-button type="primary" size="small"
                       @click="submitQueryForm()" icon="el-icon-search">
              查询</el-button>
            <el-button type="primary" size="small" plain
                       @click="resetQueryForm()" icon="el-icon-refresh">
              重置</el-button>
            <!--<el-button type="primary" size="small" plain
                       @click="importData()" icon="el-icon-refresh">
              导出</el-button>-->
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-card>
  <el-card body-style="padding: 1%">
    <el-tabs class="el-tabs-self" v-model="tabsActive" @tab-click="handTabClick">
      <el-tab-pane v-for="(item, index) in tabsActives" :key="index" :label="item.lable" :name="item.value+''"></el-tab-pane>
    </el-tabs>
    <el-table :data="tableData"
              ref="table"
              border default-expand-all stripe
              :header-cell-style="{'text-align':'center'}"
              :max-height="tableHeight"
              style="width: 100%;margin-bottom: 20px;"
              :cell-style="{'text-align':'center'}"
              @selection-change="handleSelectionChange">
      <el-table-column label="全选" width="50" type="selection"/>
      <el-table-column prop="taskId" width="120" label="任务编号">
        <!--<template slot-scope="scope">
          <span>{{ getStrEndWithNumbers(scope.row.taskId) }}</span>
        </template>-->
      </el-table-column>
      <el-table-column prop="businessName" label="商家" />
      <el-table-column prop="shopName" label="店铺" />
      <el-table-column prop="taskTitle" label="任务标题" width="160" />
      <el-table-column prop="taskType" label="任务类型" />
      <el-table-column prop="returnType" label="返款类型" />
      <el-table-column prop="moneyReturn" label="本金返款" />
      <el-table-column prop="taskNumbers" label="数量" />
      <el-table-column prop="statusStr" label="状态" />
      <el-table-column prop="releaseTime" label="发布时间" />
      <el-table-column prop="remarks" label="备注" />
      <el-table-column label="操作" width="220" align="center">
        <template slot-scope="scope">
          <el-row >
            <el-col :span="24">
              <el-button size="mini" type="primary" plain
                         @click="handleLocalEdit(scope.$index, scope.row,'设置任务-'+ getStrEndWithNumbers(scope.row.taskId))">
                设置
              </el-button>
              <el-button size="mini" type="primary" plain
                         @click="goToTaskDetail(scope.$index, scope.row)">
                查看
              </el-button>
              <el-button size="mini" type="primary" plain v-if="scope.row.statusStr == '待审核任务'"
                         @click="handleEdit(scope.$index, scope.row,'修改字典项')">
                审核
              </el-button>
            </el-col>
          </el-row>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        :page-sizes="[20, 50, 100, 200]"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        @size-change="handlePageSizeChange"
        @current-change="handlePageNumChange"
        background
        style="float: right;margin-bottom: 10px">
    </el-pagination>
  </el-card>

  <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible">
    <el-form ref="dialogForm" :model="dialogForm" label-width="120px" size="mini">
      <el-form-item label="任务问题">
        <el-input v-model="dialogForm.taskQuestion" style="width: 50%;"></el-input>
      </el-form-item>
      <el-form-item label="任务答案">
        <el-input v-model="dialogForm.goodsAnswers" style="width: 50%;"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="submitLocationDialogForm" size="mini" type="primary">提交</el-button>
      <el-button @click="handleCloseDialog" size="mini">取 消</el-button>
    </div>
  </el-dialog>
</div>
</template>

<script>
import MixinCUD from '@/components/MixinCUD'
import {getAdminTaskInfo, queryTaskQuestion, updateTaskQuestion} from "../../api/b2cbusiness/b2c_tasklist";
import {getStrEndWithNumbers} from "../../lib/utils";
import {getAllTaskType} from "../../api/b2cbusiness/b2c_tasktype";
import MinxinScroll from "@/components/MinxinScroll";
export default {
  name: "TaskManagelist",
  mixins:[MixinCUD, MinxinScroll],
  data(){
    return {
      tableData:[],
      allTaskTypes: [],
      queryFormRefName:"queryForm",
      queryForm:{
        taskId: null,
        businessName: '',
        taskTitle: '',
        taskType: null,
      },
      dialogFormVisible: false,
      dialogTitle: "",
      dialogRefName: "dialogForm",
      dialogForm: {
      },
      tabsActive: 0,
      tabsActives: {
        0:{
          lable:"所有任务",
          value:0
        },
        202112260001:{
          lable:"待审核任务",
          value:202112260001
        },
        202112260002:{
          lable:"进行中任务",
          value:202112260002
        },
        202112260003:{
          lable:"已完成任务",
          value:202112260003
        },
        202112260004:{
          lable:"已终止任务",
          value:202112260004
        },
        202112260005:{
          lable:"审核未过任务",
          value:202112260005
        }
      },
      tableHeight: 850,
      pagination:{
        pageNum: 1,
        pageSize: 20,
        total: null
      },
    }
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 320;
    //console.log(document.body.clientHeight, this.tableHeight)
  },
  mounted() {
    //this.tableHeight = document.body.clientHeight - 220;
    getAllTaskType().then(res=>{
      if (res.success){
        this.allTaskTypes = res.data;
      }
    });
    if (this.$route.query.tabsActive != null){
      this.tabsActive = this.$route.query.tabsActive;
      this.getTaskInfoWithStatus(this.tabsActives[this.this.$route.query.tabsActive].name);
      this.$forceUpdate();
    }else{
      this.getData();
    }
  },
  methods: {
    handleLocalEdit(index, row,dialogTitle){
      this.dialogFormVisible = true;
      this.dialogTitle = dialogTitle
      this.resetDialogForm()
      this.dialogForm = {...row}
      queryTaskQuestion({taskId:row.taskId}).then(res=>{
        if(res.success){
          this.dialogForm.taskQuestion = res.data.taskQuestion;
          this.dialogForm.goodsAnswers = res.data.goodsAnswers;
          this.$forceUpdate();
          //console.log(this.dialogForm)
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    goToTaskDetail(index, row){
        this.$router.push({path:"/home/businesstaskdetails", query: {b2cTaskId:row.taskId}})
    },
    handTabClick(tab, event){
      //console.log(tab, tab.label, tab.name, event)
      this.getTaskInfoWithStatus(tab.name);
    },
    getStrEndWithNumbers(numbers) {
      return getStrEndWithNumbers(numbers, 8);
    },
    getData(){
      getAdminTaskInfo(this.queryForm, this.pagination).then(res=>{
        if (res.success){
          this.tableData = res.data.records;
          this.pagination.pageNum = res.data.current;
          this.pagination.pageSize = res.data.size;
          this.pagination.total = res.data.total;
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    getTaskInfoWithStatus(taskCode){
      getAdminTaskInfo({status:taskCode}, this.pagination).then(res=>{
        if (res.success){
          this.tableData = res.data.records;
          this.pagination.pageNum = res.data.current;
          this.pagination.pageSize = res.data.size;
          this.pagination.total = res.data.total;
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    submitLocationDialogForm(){
      this.$refs[this.dialogRefName].validate((valid) => {
        if (valid) {
          this.$confirm("确定提交数据么?")
              .then(_ => {
                this.updateData();
                //取消新增或修改也要重置表单
              }).catch(err => {this.handleCloseDialog();});
        } else {
          return false;
        }
      });
    },
    updateData(){
      updateTaskQuestion(this.dialogForm).then(res=>{
        //console.log(this.dialogForm)
        if (res.success){
          this.$message.success("更新数据成功！")
          this.dialogFormVisible=false;
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    handlePageSizeChange(val) {
      this.pagination.pageSize = val;
      this.submitQueryForm()
    },
    handlePageNumChange(val) {
      this.pagination.pageNum = val;
      this.submitQueryForm()
      //切换页面恢复到顶部
      this.scrollTop = 0
      this.saveScroll()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form {
  margin-top: 20px;
}

.el-tabs-self{
  position: relative;
  width: 100%;
}
</style>
